// Límite de carga por lavadora.
//
// Una lavadora admite como máximo un 30% por encima de su capacidad nominal.
// El peso que se compara es el PESO HÚMEDO que el operario digita en el
// formulario (lo que marca la báscula), no el peso neto ya descontada la
// humedad del centro.
export const MAX_LOAD_FACTOR = 1.3;

// Porcentaje de exceso permitido, para textos en la interfaz ("30%").
export const MAX_LOAD_EXTRA_PERCENT = Math.round((MAX_LOAD_FACTOR - 1) * 100);

// Devuelve el peso máximo permitido (kg) para una lavadora, o 0 si la máquina
// no tiene capacidad parametrizada (en ese caso no se aplica el límite).
export const getMaxLoadForMachine = (machine) => {
  const capacidad = Number(machine?.capacidad);
  if (!Number.isFinite(capacidad) || capacidad <= 0) return 0;
  return Number((capacidad * MAX_LOAD_FACTOR).toFixed(2));
};
